import { styled } from '@pata-app/themes';

export const BusinessBenefitsContainer = styled.section`
  display: grid;

  > div {
    display: flex;
    align-items: center;
    flex-direction: column;

    padding: 70px 0;
  }

  img {
    width: 80%;

    border-radius: ${({ theme }) => theme.core.border.container.radius}px;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.m}`} {
    img {
      width: 60%;
    }

    button {
      cursor: pointer;
      min-width: 150px;
    }
  }
  @media ${({ theme }) => `${theme.core.breakpoints.l}`} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 70px auto 70px;

    overflow: hidden;
    > div {
      display: flex;
      align-items: normal;
      flex-direction: row-reverse;
      justify-content: center;
      grid-column: 1 / span 4;
      grid-row: 2 / span 1;

      padding: 0;

      max-width: 1200px;
    }

    img {
      object-fit: cover;

      height: 450px;
      width: 30%;
    }
  }
`;

export const BusinessBenefitsContent = styled.div`
  height: min-content;

  align-self: center;

  margin: ${({ theme }) => theme.core.sizing[2]}px ${({ theme }) => theme.core.sizing[4]}px;
  /* padding: ${({ theme }) => theme.core.sizing[2]}px; */

  h2 {
    margin: 0;

    font-size: 32px;

    span {
      color: ${({ theme }) => theme.core.colors.primary.green.medium};
    }
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.core.sizing[2]}px;

    padding: 0;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.s}`} {
    margin: 16px 0;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.l}`} {
    padding: 32px;
    width: 60%;

    margin: 0;
    margin-top: initial;
  }

  @media ${({ theme }) => `${theme.core.breakpoints.xxl}`} {
    padding: ${({ theme }) => theme.core.sizing[4]}px 120px 64px 0;
    padding-top: 70px;
    width: 60%;
  }
`;

export const BusinessBenefit = styled.li`
  list-style: none;

  strong {
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    font-family: ${({ theme }) => theme.core.fontFamily.openSans};
    font-size: 16px;
    font-weight: 600;
  }
  p {
    grid-column: 2 / span 1;
    grid-row: 2 / span 1;
    margin: 0;
    font-family: ${({ theme }) => theme.core.fontFamily.openSans};
    font-size: ${({ theme }) => theme.core.fontSizes.m}px;
    font-weight: 300;
  }

  svg {
    flex: 0 0 auto;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  align-self: flex-start;
  gap: ${({ theme }) => theme.core.sizing[2]}px;

  margin-top: ${({ theme }) => theme.core.sizing[4]}px;

  button {
    border: none;
  }
`;
